import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { Grid, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { selectJobDescription } from '@AMIEWEB/NewOrder/Store/Order.selectors';
import { UnitDetailsTextArea } from '@AMIEWEB/Order/OrderCreationForm/Common/UnitDetailsCommonTextArea';

const useStyles = makeStyles()(theme => ({
  note: {
    font: 'italic normal normal 12px/16px Roboto',
    letterSpacing: ' 0px',
    color: '#9A9D9F',
    opacity: '1',
  },
}));
const ExternalJobDescriptionContainer = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { control } = useFormContext();
  const selectedOrderJobDescription = useSelector(selectJobDescription);

  return (
    <Grid container rowSpacing={1}>
      <Grid item xs={12}>
        <Controller
          control={control}
          name={'jobDescription'}
          render={({ field }) => (
            <UnitDetailsTextArea
              fieldLabel={t('facility.units.unitDetails.unitDetails.jobDescription.externalJobDescription')}
              fieldName={'jobDescription'}
              id={'jobDescription'}
              onChange={field.onChange}
              isDisabled={false}
              inputValue={field.value}
              defaultInputValue={selectedOrderJobDescription ?? ''}
              showMaxCount
              maxCharacters={8000}
              customHelperText={
                <Typography className={classes.note} component="span" variant="body2">
                  {t('facility.units.unitDetails.unitDetails.jobDescription.notes')}
                </Typography>
              }
            />
          )}
        />
      </Grid>
    </Grid>
  );
};

export default ExternalJobDescriptionContainer;
